import { saveSupportRoleUsers } from '../../../api/admin/rbac';
import { RbacRoleType } from '../../../model';
import { IApiAdminRbacRole } from '../../../model/api-modules';

export const washRoleUsers = async (
  operateRole: IApiAdminRbacRole,
  newUserList: string[],
  commonRoles: IApiAdminRbacRole[],
  operator: string
) => {
  // 新加入的admin, 需要删除自定义角色
  if (operateRole?.type === RbacRoleType.Admin) {
    const updateRoles = commonRoles
      .filter((roleItem) =>
        roleItem.userList.some((userId) => newUserList.includes(userId))
      )
      .map((roleItem) => {
        return {
          roleId: roleItem.roleId,
          operator,
          userIdList: roleItem.userList.filter(
            (userId) => !newUserList.includes(userId)
          ),
        };
      });

    await Promise.all(
      updateRoles.map(async (roleItem) => {
        return saveSupportRoleUsers(roleItem);
      })
    );
  }
};
